var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg0IconFillCloseCircleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F64E5F",
    d: "M8 1C4.134 1 1 4.134 1 8s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm2.584 9.66l-1.03-.005L8 8.803l-1.552 1.85-1.032.005c-.07 0-.125-.055-.125-.125 0-.03.01-.058.03-.081L7.352 8.03 5.32 5.61c-.018-.024-.03-.052-.03-.082 0-.069.057-.125.126-.125l1.032.005L8 7.259l1.552-1.85 1.03-.004c.07 0 .126.054.126.125 0 .03-.011.058-.03.08l-2.03 2.421 2.032 2.422c.018.024.03.052.03.081 0 .07-.057.125-.126.125z",
    transform: "translate(-756 -394) translate(740 382) translate(16 12)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0IconFillCloseCircleFill);
export default __webpack_public_path__ + "static/media/0-icon-fill-close-circle-fill.51954887.svg";
export { ForwardRef as ReactComponent };